import React, { useEffect, useRef, useState, useMemo } from 'react';
import '../styles/MapContainer.css';
import { useLang } from "../use/lang";
import { useDispatch, useSelector } from "react-redux";
import { selectChosenMapTypes } from "../store/map/selectors";
import { mapSetAll, mapToggleChosen, mapUnsetAll } from "../store/map/actions";
import Button from "@mui/material/Button";
import HomeIcon from '@mui/icons-material/Home';
import {
    getAllTypes, getCastleElek1Elements, getCastleGavot1Elements, getCastleKandur1Elements, getCastleKandur2Elements,
    getChoiceElements, getDungeonTypes,
    getGraveyardBangvil10Elements,
    getGraveyardBangvil11Elements, getGraveyardBangvil12Elements, getGraveyardBangvil20Elements,
    getGraveyardBangvil21Elements, getGraveyardShipstone10Elements, getGraveyardShipstone11Elements,
    getGraveyardShipstone12Elements, getGraveyardShipstone13Elements,
    getGraveyardSunpool10Elements, getGraveyardSunpool11Elements, getGraveyardSunpool12Elements,
    getGraveyardSunpool20Elements,
    getGraveyardSunpool21Elements, getGraveyardSunpool22Elements, getGraveyardSunpool23Elements,
    getGraveyardSunpool24Elements, getGraveyardSunpool25Elements,
    getGraveyardTorvil10Elements, getGraveyardTorvil11Elements,
    getGraveyardTorvil20Elements, getGraveyardTorvil21Elements,
    getHaronElements,
    getHyperionElements,
    getLeonElements, getOthersFD10Elements, getOthersFD11Elements, getOthersFD12Elements,
    getOthersFD20Elements, getOthersFD21Elements,
    getOthersFD22Elements, getOthersFD30Elements, getOthersFD31Elements, getOthersFD32Elements, getOthersFD33Elements,
    getOthersFD40Elements,
    getOthersFD41Elements,
    getOthersFD42Elements,
    getPhoebusElements, getQuestCave10Elements,
    getQuestHole10Elements,
    getQuestHole20Elements, getQuestHole30Elements, getQuestMineshaft10Elements, getQuestMineshaft11Elements,
    getQuestMineshaft20Elements, getQuestMineshaft30Elements, getQuestMineshaft40Elements,
    getQuestMineshaft41Elements, getQuestMineshaft50Elements, getQuestPrison10Elements,
    getQuestPrison20Elements,
    getRhodesElements,
    getTypes
} from "../utils/mapUtils";
import { scroll } from "../utils/scrollIntoView";
import menuConfig from "../utils/menuConfig";

const mapElementsSources = {
    'world': null,
    'hyper': getHyperionElements,
    'haron': getHaronElements,
    'rhodes': getRhodesElements,
    'phoebus': getPhoebusElements,
    'leon': getLeonElements,
    'choice': getChoiceElements,
    'elec-level-0': getCastleElek1Elements,
    'gavot-level-0': getCastleGavot1Elements,
    'candour-level-0': getCastleKandur1Elements,
    'candour-level-1': getCastleKandur2Elements,
    'fd-1-1': getOthersFD11Elements,
    'fd-1-0': getOthersFD10Elements,
    'fd-1-2': getOthersFD12Elements,
    'fd-2-1': getOthersFD21Elements,
    'fd-2-2': getOthersFD22Elements,
    'fd-2-0': getOthersFD20Elements,
    'fd-3-3': getOthersFD33Elements,
    'fd-3-2': getOthersFD32Elements,
    'fd-3-1': getOthersFD31Elements,
    'fd-3-0': getOthersFD30Elements,
    'fd-4-2': getOthersFD42Elements,
    'fd-4-1': getOthersFD41Elements,
    'fd-4-0': getOthersFD40Elements,
    'graveyard-torvil-1-0': getGraveyardTorvil10Elements,
    'graveyard-torvil-1-1': getGraveyardTorvil11Elements,
    'graveyard-torvil-2-0': getGraveyardTorvil20Elements,
    'graveyard-torvil-2-1': getGraveyardTorvil21Elements,
    'graveyard-bangvil-1-0': getGraveyardBangvil10Elements,
    'graveyard-bangvil-1-1': getGraveyardBangvil11Elements,
    'graveyard-bangvil-1-2': getGraveyardBangvil12Elements,
    'graveyard-bangvil-2-0': getGraveyardBangvil20Elements,
    'graveyard-bangvil-2-1': getGraveyardBangvil21Elements,
    'graveyard-shipstone-1-1': getGraveyardShipstone11Elements,
    'graveyard-shipstone-1-0': getGraveyardShipstone10Elements,
    'graveyard-shipstone-1-2': getGraveyardShipstone12Elements,
    'graveyard-shipstone-1-3': getGraveyardShipstone13Elements,
    'graveyard-sunpool-1-1': getGraveyardSunpool11Elements,
    'graveyard-sunpool-1-0': getGraveyardSunpool10Elements,
    'graveyard-sunpool-1-2': getGraveyardSunpool12Elements,
    'graveyard-sunpool-2-1': getGraveyardSunpool21Elements,
    'graveyard-sunpool-2-0': getGraveyardSunpool20Elements,
    'graveyard-sunpool-2-2': getGraveyardSunpool22Elements,
    'graveyard-sunpool-2-3': getGraveyardSunpool23Elements,
    'graveyard-sunpool-2-4': getGraveyardSunpool24Elements,
    'graveyard-sunpool-2-5': getGraveyardSunpool25Elements,
    'cave-1-0': getQuestCave10Elements,
    'mineshaft-1-0': getQuestMineshaft10Elements,
    'mineshaft-1-1': getQuestMineshaft11Elements,
    'mineshaft-2-0': getQuestMineshaft20Elements,
    'mineshaft-3-0': getQuestMineshaft30Elements,
    'mineshaft-4-0': getQuestMineshaft40Elements,
    'mineshaft-4-1': getQuestMineshaft41Elements,
    'mineshaft-5-0': getQuestMineshaft50Elements,
    'hole-1-0': getQuestHole10Elements,
    'hole-2-0': getQuestHole20Elements,
    'hole-3-0': getQuestHole30Elements,
    'prison-1-0': getQuestPrison10Elements,
    'prison-2-0': getQuestPrison20Elements
};

function getNodeFromPath(path) {
    let current = { children: menuConfig };
    for (const id of path) {
        const child = current.children?.find(c => c.id === id);
        if (!child) return null;
        current = child;
    }
    return current;
}

function findFirstLeafWithImage(node) {
    if (!node) return null;
    if (node.image) return node;

    if (node.levels && node.levels.length > 0) {
        return node;
    }

    if (node.children) {
        if (node.defaultLevel) {
            const defaultChild = node.children.find(c => c.id === node.defaultLevel);
            if (defaultChild) {
                const leaf = findFirstLeafWithImage(defaultChild);
                if (leaf) return leaf;
            }
        }
        for (const child of node.children) {
            const result = findFirstLeafWithImage(child);
            if (result) return result;
        }
    }
    return null;
}

function findItemById(id) {
    function search(node) {
        if (node.id === id) return node;
        if (node.children) {
            for (const child of node.children) {
                const found = search(child);
                if (found) return found;
            }
        }
        return null;
    }
    return search({ children: menuConfig });
}

function isLevelNode(id) {
    const node = findItemById(id);
    if (!node) return false;
    if (node.isLevel) return true;
    function searchParent(current, targetId, parent) {
        if (current.id === targetId) {
            return parent;
        }
        if (current.children) {
            for (const child of current.children) {
                const result = searchParent(child, targetId, current);
                if (result) return result;
            }
        }
        return null;
    }
    const parent = searchParent({ children: menuConfig }, id, null);
    return !!(parent && parent.levels);
}

const MapContainer = () => {
    const { texts, buttons } = useLang();
    const mapImageRef = useRef(null);
    const containerRef = useRef(null);
    const [overlayStyle, setOverlayStyle] = useState({});
    const hyperRef = useRef(null);
    const charonRef = useRef(null);
    const phoebusRef = useRef(null);
    const rhodesRef = useRef(null);
    const [imageLoaded, setImageLoaded] = useState(false);

    const selectedTypes = useSelector(selectChosenMapTypes);
    const dispatch = useDispatch();

    const [chosenMap, setChosenMap] = useState('world');
    const [chosenCastle, setChosenCastle] = useState(null);
    const [currentFloor, setCurrentFloor] = useState(null);
    const [currentLevelId, setCurrentLevelId] = useState(null);

    const [menuPath, setMenuPath] = useState([]);
    const [isMenuOpen, setIsMenuOpen] = useState(true);
    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

    const [mouseOver, setMouseOver] = useState('');
    const [mouseCoords, setMouseCoords] = useState({ x: 0, y: 0, percentX: 0, percentY: 0 });
    const mapContainerRef = useRef(null);

    const castleNames = [
        "elec-level-0",
        "gavot-level-0",
        "candour-level-0",
        "candour-level-1",
        "fd-1-1",
        "fd-1-0",
        "fd-1-2",
        "fd-2-1",
        "fd-2-0",
        "fd-2-2",
        "fd-3-1",
        "fd-3-0",
        "fd-3-2",
        "fd-3-3",
        "fd-4-0",
        "fd-4-2",
        "fd-4-1",
        "graveyard-torvil-1-0",
        "graveyard-torvil-1-1",
        "graveyard-torvil-2-0",
        "graveyard-torvil-2-1",
        "graveyard-bangvil-1-0",
        "graveyard-bangvil-1-1",
        "graveyard-bangvil-1-2",
        "graveyard-bangvil-2-0",
        "graveyard-bangvil-2-1",
        "graveyard-shipstone-1-0",
        "graveyard-shipstone-1-1",
        "graveyard-shipstone-1-2",
        "graveyard-shipstone-1-3",
        "graveyard-sunpool-1-0",
        "graveyard-sunpool-1-1",
        "graveyard-sunpool-1-2",
        "graveyard-sunpool-2-0",
        "graveyard-sunpool-2-1",
        "graveyard-sunpool-2-2",
        "graveyard-sunpool-2-3",
        "graveyard-sunpool-2-4",
        "graveyard-sunpool-2-5",
        "cave-1-0",
        "mineshaft-1-0",
        "mineshaft-1-1",
        "mineshaft-2-0",
        "mineshaft-3-0",
        "mineshaft-4-0",
        "mineshaft-4-1",
        "mineshaft-5-0",
        "hole-1-0",
        "hole-2-0",
        "hole-3-0",
        "prison-1-0",
        "prison-2-0",
    ]

    const types = castleNames.find(l => l === chosenMap) ? getDungeonTypes() : getTypes();

    let allTypes = getAllTypes();

    const currentNode = getNodeFromPath(menuPath);
    let childrenToShow;
    if (currentNode && !currentNode.children && currentNode.levels) {
        childrenToShow = currentNode.levels.map(level => ({
            ...level,
            isLevel: true,
        }));
    } else {
        childrenToShow = currentNode?.children || menuConfig;
    }

    const selectedItem = findItemById(chosenMap);

    // Вычисляем URL карты
    const computedImageUrl = useMemo(() => {
        if (chosenCastle) {
            return `${process.env.REACT_APP_BACKEND_URL}/image/${chosenCastle}_floor_${currentFloor}`;
        } else if (selectedItem && selectedItem.image) {
            return `${process.env.REACT_APP_BACKEND_URL}${selectedItem.image}`;
        } else if (selectedItem && selectedItem.levels && currentLevelId) {
            const level = selectedItem.levels.find(l => l.id === currentLevelId);
            if (level && level.image) {
                return `${process.env.REACT_APP_BACKEND_URL}${level.image}`;
            }
        }
        return `${process.env.REACT_APP_BACKEND_URL}/image/${chosenMap}`;
    }, [chosenMap, chosenCastle, currentFloor, currentLevelId, selectedItem]);

    // Состояния для анимации смены карты
    const [displayedImageUrl, setDisplayedImageUrl] = useState(computedImageUrl);
    const [isTransitioning, setIsTransitioning] = useState(false);

    // Запускаем анимацию при изменении computedImageUrl
    useEffect(() => {
        if (computedImageUrl !== displayedImageUrl) {
            setIsTransitioning(true); // начинаем исчезать
            const timer = setTimeout(() => {
                setDisplayedImageUrl(computedImageUrl); // меняем src
                setIsTransitioning(false); // начинаем появляться
            }, 250);
            return () => clearTimeout(timer);
        }
    }, [computedImageUrl]);

    // Инициализация первого URL
    useEffect(() => {
        if (!displayedImageUrl) {
            setDisplayedImageUrl(computedImageUrl);
        }
    }, []);

    // Хлебные крошки
    function getBreadcrumbs() {
        const crumbs = [];
        crumbs.push({ id: 'home', label: <HomeIcon />, isHome: true });

        let current = { children: menuConfig };
        for (const id of menuPath) {
            const child = current.children?.find(c => c.id === id);
            if (!child) break;
            crumbs.push({ id: child.id, label: child.label });
            current = child;
        }

        if (menuPath.includes('world')) {
            const worldNode = menuConfig.find(c => c.id === 'world');
            const isWorldMapItem = worldNode?.children?.some(c => c.id === chosenMap);
            if (isWorldMapItem && chosenMap !== 'world') {
                if (!crumbs.some(c => c.id === chosenMap)) {
                    const item = findItemById(chosenMap);
                    if (item && item.image) {
                        crumbs.push({ id: chosenMap, label: item.label });
                    }
                }
            }
        }

        return crumbs;
    }

    const breadcrumbs = getBreadcrumbs();

    const handleBreadcrumbClick = (index) => {
        const crumb = breadcrumbs[index];
        if (crumb.isHome) {
            setMenuPath([]);
            setChosenMap('world');
            setChosenCastle(null);
            setCurrentFloor(null);
            setCurrentLevelId(null);
            return;
        }

        if (crumb.id === 'world') {
            setMenuPath(['world']);
            setChosenMap('world');
            setChosenCastle(null);
            setCurrentFloor(null);
            setCurrentLevelId(null);
            return;
        }

        const newPath = menuPath.slice(0, index);
        setMenuPath(newPath);
        if (newPath.length === 0) {
            setChosenMap('world');
            setChosenCastle(null);
            setCurrentFloor(null);
            setCurrentLevelId(null);
        }
    };

    const updateOverlayPosition = () => {
        const baseImage = mapImageRef.current;
        if (baseImage) {
            const { offsetWidth, offsetHeight, offsetLeft, offsetTop } = baseImage;
            setOverlayStyle({
                position: 'absolute',
                top: `${offsetTop}px`,
                left: `${offsetLeft}px`,
                width: `${offsetWidth}px`,
                height: `${offsetHeight}px`
            });
        }
    };

    const handleMouseMove = (event) => {
        if (mapImageRef.current) {
            const imageRect = mapImageRef.current.getBoundingClientRect();
            const mouseX = event.clientX;
            const mouseY = event.clientY;
            const relativeX = mouseX - imageRect.left;
            const relativeY = mouseY - imageRect.top;
            const percentX = (relativeX / imageRect.width) * 100;
            const percentY = (relativeY / imageRect.height) * 100;
            setMouseCoords({
                x: Math.round(relativeX),
                y: Math.round(relativeY),
                percentX: percentX.toFixed(2),
                percentY: percentY.toFixed(2)
            });
        }
    };

    useEffect(() => {
        if (mapContainerRef) {
            scroll(mapContainerRef, 'instant');
        }
    }, [mapContainerRef]);

    // Обновляем позицию оверлея при загрузке картинки или изменении её размера
    useEffect(() => {
        const imageElement = mapImageRef.current;
        if (imageElement) {
            imageElement.onload = () => {
                updateOverlayPosition();
            };
            if (imageElement.complete) {
                updateOverlayPosition();
            }
        }
        window.addEventListener('resize', updateOverlayPosition);
        return () => {
            window.removeEventListener('resize', updateOverlayPosition);
        };
    }, [displayedImageUrl]);

    const handleMenuItemClick = (item) => {
        if (item.id === 'world') {
            setMenuPath(['world']);
            setChosenMap('world');
            setChosenCastle(null);
            setCurrentFloor(null);
            setCurrentLevelId(null);
            return;
        }

        if (item.children && item.children.length > 0) {
            if (item.isDungeon) {
                const defaultLevel = item.defaultLevel || item.children[0].id;
                const defaultChild = item.children.find(c => c.id === defaultLevel);
                if (defaultChild && defaultChild.image) {
                    setChosenMap(defaultChild.id);
                    setChosenCastle(null);
                    setCurrentFloor(null);
                    setCurrentLevelId(null);
                } else {
                    const firstWithImage = item.children.find(c => c.image);
                    if (firstWithImage) {
                        setChosenMap(firstWithImage.id);
                    }
                }
                setMenuPath([...menuPath, item.id]);
                return;
            }
            setMenuPath([...menuPath, item.id]);
            return;
        }

        if (item.levels && item.levels.length > 0) {
            setMenuPath([...menuPath, item.id]);
            const defaultLevel = item.defaultLevel || item.levels[0].id;
            const level = item.levels.find(l => l.id === defaultLevel);
            if (level && level.image) {
                setChosenMap(level.id);
                setChosenCastle(null);
                setCurrentFloor(null);
                setCurrentLevelId(null);
            } else {
                const firstWithImage = item.levels.find(l => l.image);
                if (firstWithImage) {
                    setChosenMap(firstWithImage.id);
                }
            }
            return;
        }

        if (item.image) {
            setChosenMap(item.id);
            setChosenCastle(null);
            setCurrentFloor(null);
            setCurrentLevelId(null);
            const worldNode = menuConfig.find(c => c.id === 'world');
            const isWorldMapItem = worldNode?.children?.some(c => c.id === item.id);
            if (isWorldMapItem && !menuPath.includes('world')) {
                setMenuPath([...menuPath, 'world']);
            }
            return;
        }
    };

    const handleBack = () => {
        if (menuPath.length > 0) {
            const newPath = menuPath.slice(0, -1);
            setMenuPath(newPath);
            if (newPath.length === 0) {
                setChosenMap('world');
                setChosenCastle(null);
                setCurrentFloor(null);
                setCurrentLevelId(null);
            }
        } else {
            setChosenMap('world');
            setChosenCastle(null);
            setCurrentFloor(null);
            setCurrentLevelId(null);
        }
    };

    const handleChoose = (e) => {
        e.stopPropagation();
        if (e.target.id) {
            dispatch(mapToggleChosen(e.target.id));
            return;
        }
        if (e.target.parentNode.id) {
            dispatch(mapToggleChosen(e.target.parentNode.id));
        }
    };

    const handleSet = () => {
        dispatch(mapSetAll(allTypes));
    };

    const handleUnset = () => {
        dispatch(mapUnsetAll());
    };

    const quickMenuStyles = {
        position: 'absolute',
        top: '20px',
        left: '20px',
        zIndex: 2000,
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        padding: '10px',
        borderRadius: '8px'
    };

    const isWorldMap = chosenMap === 'world' && !chosenCastle;

    const handleWorldMapClick = (mapId) => {
        setChosenMap(mapId);
        setChosenCastle(null);
        setCurrentFloor(null);
        setCurrentLevelId(null);
        if (!menuPath.includes('world')) {
            setMenuPath([...menuPath, 'world']);
        }
    };

    console.log('chosenMap: ', chosenMap)

    const currentMapElements = chosenCastle
        ? []
        : (mapElementsSources[chosenMap] ? mapElementsSources[chosenMap]() : []);

    return (
        <div className="map-container">
            <div className="container--indicator" ref={mapContainerRef}></div>
            <div className="map-container__header"
                 style={{ background: `url(${process.env.REACT_APP_BACKEND_URL}/image/background) center repeat` }}>
                <div className="map-container__menu">
                    <div className="menu-icon-container menu-icon-container-map" style={{ display: 'flex', maxWidth: 30, maxHeight: 30 }} onClick={toggleMenu}>
                        <div className="menu-icon">
                            <div id="menu-icon1" className={isMenuOpen ? "change" : ""}></div>
                            <div id="menu-icon2" className={isMenuOpen ? "change" : ""}></div>
                            <div id="menu-icon3" className={isMenuOpen ? "change" : ""}></div>
                        </div>
                    </div>
                    <div className="menu-breadcrumbs">
                        {breadcrumbs.map((crumb, index) => {
                            const isLast = index === breadcrumbs.length - 1;
                            if (crumb.isHome) {
                                return (
                                    <span key={crumb.id}>
                                        <Button
                                            variant="text"
                                            className="button secondary"
                                            onClick={() => handleBreadcrumbClick(index)}
                                            style={{ padding: '0 4px', minWidth: 'auto', fontSize: '14px' }}
                                        >
                                            {crumb.label}
                                        </Button>
                                    </span>
                                );
                            }
                            return (
                                <span key={crumb.id}>
                                    {index > 0 && <span className="breadcrumb-separator"> / </span>}
                                    {isLast ? (
                                        <span className="breadcrumb-item current">{crumb.label}</span>
                                    ) : (
                                        <Button
                                            variant="text"
                                            className="button secondary"
                                            onClick={() => handleBreadcrumbClick(index)}
                                            style={{ padding: '0 4px', minWidth: 'auto', fontSize: '14px' }}
                                        >
                                            {crumb.label}
                                        </Button>
                                    )}
                                </span>
                            );
                        })}
                    </div>
                </div>
                <div></div>
            </div>

            <div className="map-container__content" ref={containerRef}>
                {isMenuOpen && (
                    <div style={quickMenuStyles}>
                        {menuPath.length > 0 && (
                            <Button variant="text" onClick={handleBack} className="button secondary">
                                ← Назад
                            </Button>
                        )}
                        {childrenToShow.map(item => {
                            const isActive = item.id === chosenMap && isLevelNode(item.id);
                            return (
                                <Button
                                    variant="text"
                                    key={item.id}
                                    onClick={() => handleMenuItemClick(item)}
                                    className={isActive ? "button secondary" : "button primary"}
                                >
                                    {item.label}
                                </Button>
                            );
                        })}
                        {chosenCastle && (() => {
                            return null;
                        })()}
                    </div>
                )}

                <img
                    src={displayedImageUrl}
                    ref={mapImageRef}
                    onLoad={() => {
                        setImageLoaded(true);
                        updateOverlayPosition();
                    }}
                    alt="Map"
                    className="map-image"
                    style={{
                        opacity: isTransitioning ? 0 : 1,
                        transition: 'opacity 0.25s ease-in-out',
                        filter: 'drop-shadow(0 0 5px rgba(243, 201, 136, 0.8))'
                    }}
                    onMouseMove={handleMouseMove}
                />

                {imageLoaded && (
                    <div className="map-icons-overlay" style={overlayStyle}>
                        {isWorldMap ? (
                            // Карта мира – без изменений
                            <>
                                <div className="map-image--world-part map-image--world-hyper" style={{animationDelay: '100ms'}}>
                                    <img src={`${process.env.REACT_APP_BACKEND_URL}/image/hyper`}
                                         alt="Hyperion map"
                                         className={mouseOver === 'hyperion-map' ? 'map-image--world-part-over hyperion-map' : 'hyperion-map'}
                                         ref={hyperRef}
                                    />
                                </div>
                                <div className="map-image--world-part map-image--world-charon" style={{animationDelay: '200ms'}}>
                                    <img src={`${process.env.REACT_APP_BACKEND_URL}/image/haron`}
                                         alt="Charon map"
                                         className={mouseOver === 'charon-map' ? 'map-image--world-part-over charon-map' : 'charon-map'}
                                         ref={charonRef}
                                    />
                                </div>
                                <div className="map-image--world-part map-image--world-phoebus" style={{animationDelay: '350ms'}}>
                                    <img src={`${process.env.REACT_APP_BACKEND_URL}/image/phoebus`}
                                         alt="Phoebus map"
                                         className={mouseOver === 'phoebus-map' ? 'map-image--world-part-over phoebus-map' : 'phoebus-map'}
                                         ref={phoebusRef}
                                    />
                                </div>
                                <div className="map-image--world-part map-image--world-rhodes" style={{animationDelay: '500ms'}}>
                                    <img src={`${process.env.REACT_APP_BACKEND_URL}/image/rhodes`}
                                         alt="Rhodes map"
                                         className={mouseOver === 'rhodes-map' ? 'map-image--world-part-over rhodes-map' : 'rhodes-map'}
                                         ref={rhodesRef}
                                    />
                                </div>
                                <div className="map-image--world-part map-image--world-choice" style={{animationDelay: '700ms'}}>
                                    <img src={`${process.env.REACT_APP_BACKEND_URL}/image/choice`}
                                         alt="Island of Choice map"
                                         className={mouseOver === 'choice-map' ? 'map-image--world-part-over choice-map' : 'choice-map'}
                                    />
                                </div>
                                <div className="map-image--world-part map-image--world-leon" style={{animationDelay: '1000ms'}}>
                                    <img src={`${process.env.REACT_APP_BACKEND_URL}/image/leon`}
                                         alt="Leon Island map"
                                         className={mouseOver === 'leon-map' ? 'map-image--world-part-over leon-map' : 'leon-map'}
                                    />
                                </div>

                                <div style={{animationDelay: '300ms'}}
                                     className={mouseOver === 'hyperion-map' ? "map-container__world-name hyper over" : "map-container__world-name hyper"}>{texts.hyperion}</div>
                                <div style={{animationDelay: '400ms'}}
                                     className={mouseOver === 'charon-map' ? "map-container__world-name charon over" : "map-container__world-name charon"}>{texts.charon}</div>
                                <div style={{animationDelay: '550ms'}}
                                     className={mouseOver === 'phoebus-map' ? "map-container__world-name phoebus over" : "map-container__world-name phoebus"}>{texts.phoebus}</div>
                                <div style={{animationDelay: '750ms'}}
                                     className={mouseOver === 'rhodes-map' ? "map-container__world-name rhodes over" : "map-container__world-name rhodes"}>{texts.rhodes}</div>
                                <div style={{animationDelay: '1000ms'}}
                                     className={mouseOver === 'choice-map' ? "map-container__world-name choice over" : "map-container__world-name choice"}>{texts.ov}</div>
                                <div style={{animationDelay: '1350ms'}}
                                     className={mouseOver === 'leon-map' ? "map-container__world-name leon over" : "map-container__world-name leon"}>{texts.leon}</div>

                                <div className="map-container__world map-container__map--charon1"
                                     onMouseOver={() => setMouseOver('charon-map')}
                                     onMouseLeave={() => setMouseOver('')}
                                     onClick={() => handleWorldMapClick('haron')}></div>
                                <div className="map-container__world map-container__map--charon2"
                                     onMouseOver={() => setMouseOver('charon-map')}
                                     onMouseLeave={() => setMouseOver('')}
                                     onClick={() => handleWorldMapClick('haron')}></div>
                                <div className="map-container__world map-container__map--charon3"
                                     onMouseOver={() => setMouseOver('charon-map')}
                                     onMouseLeave={() => setMouseOver('')}
                                     onClick={() => handleWorldMapClick('haron')}></div>
                                <div className="map-container__world map-container__map--charon4"
                                     onMouseOver={() => setMouseOver('charon-map')}
                                     onMouseLeave={() => setMouseOver('')}
                                     onClick={() => handleWorldMapClick('haron')}></div>
                                <div className="map-container__world map-container__map--rhodes1"
                                     onMouseOver={() => setMouseOver('rhodes-map')}
                                     onMouseLeave={() => setMouseOver('')}
                                     onClick={() => handleWorldMapClick('rhodes')}></div>
                                <div className="map-container__world map-container__map--rhodes2"
                                     onMouseOver={() => setMouseOver('rhodes-map')}
                                     onMouseLeave={() => setMouseOver('')}
                                     onClick={() => handleWorldMapClick('rhodes')}></div>
                                <div className="map-container__world map-container__map--rhodes3"
                                     onMouseOver={() => setMouseOver('rhodes-map')}
                                     onMouseLeave={() => setMouseOver('')}
                                     onClick={() => handleWorldMapClick('rhodes')}></div>
                                <div className="map-container__world map-container__map--phoebus1"
                                     onMouseOver={() => setMouseOver('phoebus-map')}
                                     onMouseLeave={() => setMouseOver('')}
                                     onClick={() => handleWorldMapClick('phoebus')}></div>
                                <div className="map-container__world map-container__map--phoebus2"
                                     onMouseOver={() => setMouseOver('phoebus-map')}
                                     onMouseLeave={() => setMouseOver('')}
                                     onClick={() => handleWorldMapClick('phoebus')}></div>
                                <div className="map-container__world map-container__map--phoebus3"
                                     onMouseOver={() => setMouseOver('phoebus-map')}
                                     onMouseLeave={() => setMouseOver('')}
                                     onClick={() => handleWorldMapClick('phoebus')}></div>
                                <div className="map-container__world map-container__map--hyperion1"
                                     onMouseOver={() => setMouseOver('hyperion-map')}
                                     onMouseLeave={() => setMouseOver('')}
                                     onClick={() => handleWorldMapClick('hyper')}></div>
                                <div className="map-container__world map-container__map--hyperion2"
                                     onMouseOver={() => setMouseOver('hyperion-map')}
                                     onMouseLeave={() => setMouseOver('')}
                                     onClick={() => handleWorldMapClick('hyper')}></div>
                                <div className="map-container__world map-container__map--hyperion3"
                                     onMouseOver={() => setMouseOver('hyperion-map')}
                                     onMouseLeave={() => setMouseOver('')}
                                     onClick={() => handleWorldMapClick('hyper')}></div>
                                <div className="map-container__world map-container__map--hyperion4"
                                     onMouseOver={() => setMouseOver('hyperion-map')}
                                     onMouseLeave={() => setMouseOver('')}
                                     onClick={() => handleWorldMapClick('hyper')}></div>
                                <div className="map-container__world map-container__map--leon1"
                                     onMouseOver={() => setMouseOver('leon-map')}
                                     onMouseLeave={() => setMouseOver('')}
                                     onClick={() => handleWorldMapClick('leon-with-castle')}></div>
                                <div className="map-container__world map-container__map--choice1"
                                     onMouseOver={() => setMouseOver('choice-map')}
                                     onMouseLeave={() => setMouseOver('')}
                                     onClick={() => handleWorldMapClick('choice')}></div>
                                <div className="map-container__world map-container__map--choice2"
                                     onMouseOver={() => setMouseOver('choice-map')}
                                     onMouseLeave={() => setMouseOver('')}
                                     onClick={() => handleWorldMapClick('choice')}></div>
                            </>
                        ) : (
                            currentMapElements.map(element => {
                                if (!selectedTypes?.some(chsn => chsn.name === element.type)) {
                                    return null;
                                }
                                const thisChosenType = selectedTypes.find(tp => tp.name === element.type);
                                return (
                                    <div
                                        key={'map-element-' + element.id}
                                        className={`map-element map-element--${element.type}`}
                                        style={{
                                            position: 'absolute',
                                            left: `calc(${element.x}% - 10px)`,
                                            top: `calc(${element.y}% - 10px)`,
                                            transform: 'translate(-50%, -50%)',
                                            pointerEvents: 'auto',
                                            zIndex: thisChosenType?.type === 2 ? 1000 : 1
                                        }}
                                    >
                                        {element.iconUrl !== '/' && (
                                            <img
                                                src={`${process.env.REACT_APP_BACKEND_URL}/image${element.iconUrl}`}
                                                alt={element.name || element.type}
                                                className="map-element__icon"
                                                loading="lazy"
                                                style={{maxWidth: overlayStyle.width, maxHeight: overlayStyle.height}}
                                            />
                                        )}
                                        <div
                                            style={{ display: thisChosenType?.type === 2 ? 'flex' : 'none' }}
                                            className="map-container__icon-modal"
                                        >
                                            <div className="map-container__icon-modal-header">{element.nameRu}</div>
                                            {/*{element.descriptionRu && (*/}
                                            {/*    <div className="map-container__icon-modal-text">{element.descriptionRu}</div>*/}
                                            {/*)}*/}
                                        </div>
                                    </div>
                                );
                            })
                        )}
                    </div>
                )}
            </div>

            {chosenMap !== 'world' && <div className="map-container__chosen">
                <div className="map-container__chosen-button" onClick={handleSet}>
                    <Button variant="text" className="button primary">{buttons.selectAll}</Button>
                </div>
                <div className="map-container__chosen-icons">
                    {types.map(type => {
                        const thisChosenType = selectedTypes.find(tp => tp.name === type.name);
                        return (
                            <div
                                id={type.name}
                                key={'map-chosen-' + type.name}
                                className={selectedTypes?.some(t => t.name === type.name) ? "map-container__chosen-type chosen" : "map-container__chosen-type"}
                                style={{ backgroundColor: thisChosenType ? (thisChosenType.type === 1 ? 'rgb(234, 201, 136)' : 'rgb(245,255,250)') : 'unset' }}
                                onClick={handleChoose}
                            >
                                <img src={`${process.env.REACT_APP_BACKEND_URL}/image${type.iconUrl}`} alt={type.iconUrl} />
                            </div>
                        );
                    })}
                </div>
                <div className="map-container__chosen-button" onClick={handleUnset}>
                    <Button variant="text" className="button primary">{buttons.unsetAll}</Button>
                </div>
            </div>}
        </div>
    );
};

export default MapContainer;